var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-stack",style:(("--h-stack-gap: var(--s" + _vm.gap + "); --h-stack-padY: var(--s" + _vm.padY + ");  --h-stack-padX: var(--s" + _vm.padX + ");"))},[_c('div',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }